import React from 'react';
import { PRICE, PRICING } from '../constants/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
export function PricingOffer() {
  return <section id="oferta" className="w-full bg-white py-12 b760:py-16" data-id="element-173" data-mp="1vu52etsiqbg6">
      <div className="mx-auto max-w-2xl px-4 b720:px-6" data-id="element-174" data-mp="1vudewkkqbequ">
        <Reveal className="text-center" data-id="element-175" data-mp="1qvttcla1s4z0">
          <h2 className="font-display text-2xl font-700 uppercase leading-tight text-night b640:text-4xl" data-id="element-176" data-mp="1qwvddf91k1sv">
            {PRICING.title}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-night/80 b640:text-base" data-id="element-177" data-mp="2jj6csmkwvwo3">
            {PRICING.intro}
          </p>
        </Reveal>

        <Reveal className="mt-8" data-id="element-178" data-mp="2emg0mac89l7y">
          <div className="overflow-hidden rounded-2xl border-2 border-bordo" data-id="element-179" data-mp="29m1reoyw458c">
            <p className="bg-bordo px-4 py-3 text-center text-xs font-700 uppercase tracking-wide text-mustard b640:text-sm" data-id="element-180" data-mp="135ganldcrih3">
              {PRICING.label}
            </p>

            <ul className="divide-y divide-night/10 bg-cream" data-id="element-181" data-mp="y8g3f74ro9oe">
              {PRICING.rows.map(row => <li key={row.label} className="flex items-start justify-between gap-3 px-4 py-2.5 text-sm text-night/85 b640:text-base" data-id="element-182" data-mp="1dmuhx5zopo57">
                  <span data-id="element-183" data-mp="13sls4q21g9aq">{row.label}</span>
                  <span className="shrink-0 font-display font-600 text-night" data-id="element-184" data-mp="18p2p89r7txzy">
                    {row.value}
                  </span>
                </li>)}

              <li className="flex items-center justify-between gap-3 bg-white px-4 py-3 text-sm font-700 text-night b640:text-base" data-id="element-185" data-mp="tyv8pzkrqp1w">
                <span data-id="element-186" data-mp="l0sziwqvsq3j">{PRICING.totalLabel}</span>
                <span className="shrink-0 font-display text-lg text-bordo b640:text-xl" data-id="element-187" data-mp="kxx177b4fzek">
                  {PRICE.full}
                </span>
              </li>

              {PRICING.founderRows.map(row => <li key={row.label} className="flex items-start justify-between gap-3 bg-bordo/5 px-4 py-2.5 text-sm text-night/85 b640:text-base" data-id="element-188" data-mp="b46h0em12b4o">
                  <span data-id="element-189" data-mp="3oazegcuugfi0">{row.label}</span>
                  <span className="shrink-0 font-display font-700 uppercase text-bordo" data-id="element-190" data-mp="3o9y28523dmyp">
                    {PRICING.founderValue}
                  </span>
                </li>)}
            </ul>

            <p className="bg-cream px-4 py-3 text-xs leading-relaxed text-night/65 b640:text-sm" data-id="element-191" data-mp="3ee4fjsunsd37">
              {PRICING.note}
            </p>

            <div className="bg-bordo-deep px-5 py-7 text-center text-cream" data-id="element-192" data-mp="aw34latwam8t">
              <p className="font-display text-xl font-500 text-cream/50 line-through b640:text-2xl" data-id="element-193" data-mp="au041wv49apu">
                {PRICE.full}
              </p>
              <p className="mt-1 font-display text-5xl font-700 leading-none text-mustard b640:text-6xl" data-id="element-194" data-mp="yezps2krycx">
                {PRICE.today}
              </p>
              <p className="mx-auto mt-3 max-w-sm text-xs text-cream/75 b640:text-sm" data-id="element-195" data-mp="2ql4hw88qu8t1">
                {PRICING.kicker}
              </p>

              <div className="mt-6" data-id="element-196" data-mp="116lmpb4cl5oe">
                <CtaButton data-id="element-197" data-mp="117odlj1o784b">{PRICING.cta}</CtaButton>
                <p className="mt-2 text-xs text-cream/70" data-id="element-198" data-mp="164wvrjmtjc5k">{PRICING.ctaSub}</p>
              </div>

              <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2 text-[11px] font-600 text-cream/70 b640:text-xs" data-id="element-199" data-mp="1b4j9du6k6uew">
                {PRICING.trust.map(item => <li key={item} data-id="element-200" data-mp="1fwszba7obuh6">{item}</li>)}
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}